import { atlasCore, atlasSemantic } from './tokens';
import { typography, typographySemantic } from './typography';

export type AtlasThemeMode = 'light' | 'dark';

export function createAtlasTheme(mode: AtlasThemeMode = 'light') {
  return {
    mode,
    core: atlasCore,
    semantic: atlasSemantic,
    typography: {
      ...typography,
      semantic: typographySemantic,
    },
  } as const;
}

export type AtlasThemeResolved = ReturnType<typeof createAtlasTheme>;
